module.exports = __webpack_public_path__ + "static/media/undraw_exams_g4ow.6e98631b.svg";